import fetchData from "./fetchData.js";
//import validation from './inputValidation.js';
import htmlElement from "./htmlElements.js";
import calendarRoutine from "./calendarScript.js";
import defaultScripts from "./defaultWebsiteScript.js";
import responseMessage from "./responseMessage.js";

//Set Use Strict
("use strict");

//PATHNAME Default
const PATHNAME = window.location.pathname;

//Get Href
const HREF = window.location.origin;

//Event Created
(function () {
    //Get Current date
    let date = new Date();

    //Check routes
    if (PATHNAME.includes("/") || PATHNAME.includes("search-result")) {
        //Search Data
        const SEARCHDATA = {
            city: "",
            month: [],
            year: [],
            searchtype: document.getElementById("search-type")
                ? parseInt(document.getElementById("search-type").value)
                : 1,
            typeoflocation: 2, //Default value
            filter: {},
            filterbymonth: [],
            turndata: {
                type: "",
                datahour: {
                    begin: "",
                    end: "",
                },
                data: {},
            },
        };

        //Search Data by Interval
        let interval = [];

        //Personalized Days
        let customDays = [];

        //Get element from All Days
        let daysElementsList = [...document.querySelectorAll(".weekday")];

        //Search Result Route
        if (PATHNAME.includes("search-result")) {
            //Add Copy from search
            document.addEventListener("DOMContentLoaded", function () {
                //Get Data from Session Storage
                let searchData = sessionStorage.getItem("search_data");

                if (searchData) {
                    //Parse Data
                    searchData = JSON.parse(searchData);

                    //Set Old Search Data
                    SEARCHDATA.city = searchData.city;
                    SEARCHDATA.filter = searchData.filter;
                    SEARCHDATA.filterbymonth = searchData.filterbymonth;
                    SEARCHDATA.searchtype = searchData.searchtype;

                    //Set Searchtype in calendar modal
                    [
                        ...document.getElementById("search-type").children,
                    ].forEach((val) => {
                        if (
                            parseInt(val.value) ===
                            parseInt(SEARCHDATA.searchtype)
                        ) {
                            val.selected = true;
                        }
                    });

                    //Check Type of Location
                    [...document.querySelectorAll(".location-type")].forEach(
                        (valradio) => {
                            if (
                                parseInt(valradio.firstElementChild.value) ===
                                searchData.typeoflocation
                            ) {
                                valradio.firstElementChild.checked = true;
                                SEARCHDATA.typeoflocation = parseInt(
                                    valradio.firstElementChild.value,
                                );
                            } else {
                                valradio.firstElementChild.checked = false;
                            }
                        },
                    );

                    //Set City
                    [
                        ...document.getElementById("search-city").children,
                    ].forEach((valcity) => {
                        if (
                            valcity.hasAttribute("value") &&
                            parseInt(valcity.value) === searchData.city
                        ) {
                            valcity.setAttribute("selected", true);

                            //Active Calendar Modal
                            document
                                .getElementById("search-date")
                                .classList.remove("disabledclick");
                        }
                    });

                    //Set Text for Indicate Search
                    document.getElementById("search-date").textContent =
                        searchData.filterbymonth.length > 0
                            ? calendarRoutine.searchContentMultipleMonths(
                                  searchData.filterbymonth,
                              )
                            : calendarRoutine.searchContent(
                                  searchData.filter,
                                  searchData.filter.month,
                                  searchData.filter.year,
                              );

                    //Get Element Children from Turn Time
                    let turnTimeBaseElement = [
                        ...document.querySelector(".inputbaseinterval")
                            .children,
                    ];

                    //Remove Children Elements
                    turnTimeBaseElement.forEach((value) => {
                        if (value.getAttribute("type") !== "hidden") {
                            value.remove();
                        }
                    });

                    //Div Parent Html Element
                    let div = htmlElement.createElement("div", {
                        class: "basebtnturn",
                    });

                    //Append Children
                    document
                        .querySelector(".inputbaseinterval")
                        .appendChild(div);

                    //trabalhar aqui
                    //Create Calendar Append Element
                    calendarRoutine.createAppendElement(
                        searchData.typeoflocation,
                        "basebtnturn",
                        "select-turn-morning",
                        "select-turn-affternoon",
                        document
                            .getElementById("turn-refer-values")
                            .getAttribute("data-beginmorning"),
                        document
                            .getElementById("turn-refer-values")
                            .getAttribute("data-beginafternoon"),
                        document
                            .getElementById("turn-refer-values")
                            .getAttribute("data-blockhour"),
                    );

                    //Set Hour or Turn Search Data
                    switch (searchData.turndata.type) {
                        //Hour
                        case "hour":
                            document.getElementById(
                                "refer-value-select-turn-morning",
                            ).textContent =
                                `${searchData.turndata.datahour.begin}:00`;
                            document.getElementById(
                                "refer-value-select-turn-affternoon",
                            ).textContent =
                                `${searchData.turndata.datahour.end}:00`;

                            break;

                        //Turn
                        case "turn":
                            let divButtonTurn = [
                                ...document.querySelector(".basebtnturn")
                                    .children,
                            ];
                            let turnText = "";
                            [
                                ...divButtonTurn[0].lastElementChild.children,
                            ].forEach((valturn) => {
                                if (
                                    parseInt(
                                        valturn.getAttribute("data-value"),
                                    ) === searchData.turndata.data
                                ) {
                                    turnText = valturn.firstChild.textContent;
                                    valturn.classList.add("active");
                                }
                            });

                            document.getElementById(
                                "list-btnturn",
                            ).textContent = turnText;

                            break;
                    }
                }
            });
        }

        //Set Search City and Active search calendar modal
        document
            .getElementById("search-city")
            .addEventListener("change", function (e) {
                //Set Search Type
                SEARCHDATA.city = Number.isInteger(parseInt(this.value))
                    ? parseInt(this.value)
                    : null;

                //Active Calendar Modal
                document
                    .getElementById("search-date")
                    .classList.remove("disabledclick");
            });

        //Get Search Type
        document
            .getElementById("search-type")
            .addEventListener("change", function (e) {
                //Disable BTN
                document
                    .querySelector(".btnselectday")
                    .setAttribute("disabled", true);

                //Disabled Submit Button
                document
                    .getElementById("btnsearch")
                    .setAttribute("disabled", true);

                //Clean Old Filter Select
                SEARCHDATA.filter = {};
                SEARCHDATA.filterbymonth = [];

                //Clean Old List
                interval = [];
                customDays = [];

                //Select Day Logic - Remove Class
                daysElementsList.forEach((value) => {
                    //Remove Class
                    value.firstElementChild.classList.remove("selectday");
                });

                //Set Search Type
                SEARCHDATA.searchtype = parseInt(this.value);
            });

        //Set dynamic calendar
        [date.getFullYear(), date.getFullYear() + 1].forEach((year) => {
            //Set Years
            SEARCHDATA.year.push(year);
            //Set Year Conditional
            let i = year === date.getFullYear() ? date.getMonth() + 1 : 1;

            do {
                //Set months
                SEARCHDATA.month.push(i);

                //Change Month
                document
                    .getElementById(`calendar-header-${year}-${i}`)
                    .addEventListener("click", function (e) {
                        //Get Current Data
                        let currentMonth = this.getAttribute("data-monthrefer");
                        let currentYear = this.getAttribute("data-yearrefer");

                        //Clean Old List
                        interval = [];
                        customDays = [];

                        //Calendar Navigation
                        calendarRoutine.calendarNavigation(
                            e.target,
                            date.getFullYear(),
                            date.getFullYear() + 1,
                            date.getMonth() + 1,
                            currentYear,
                            currentMonth,
                        );
                    });

                //Get Select Date for Search
                document
                    .getElementById(`calendar-table-${year}-${i}`)
                    .addEventListener("click", function (e) {
                        //Check Element
                        if (
                            e.target.nodeName === "SPAN" ||
                            e.target.nodeName === "TD"
                        ) {
                            //Disable BTN
                            document
                                .querySelector(".btnselectday")
                                .setAttribute("disabled", true);

                            //Get Parent Element
                            let tdParentElement =
                                e.target.nodeName === "TD"
                                    ? e.target
                                    : e.target.parentElement;

                            //Get the Day Element
                            let spanElement =
                                e.target.nodeName === "SPAN"
                                    ? e.target
                                    : e.target.firstElementChild;

                            //Check Null Conditional
                            if (spanElement === null) {
                                return;
                            }

                            //Get All Td Values
                            let daysElementMonthList =
                                calendarRoutine.getAllElementsDayFromMonthCalendar(
                                    [...this.children],
                                );

                            //Select Days from Search Type
                            calendarRoutine.dynamicStrucutureForSelectDaysFromSearchType(
                                SEARCHDATA,
                                tdParentElement,
                                spanElement,
                                daysElementMonthList,
                                interval,
                                customDays,
                            );

                            //Enabled Search BTN
                            document
                                .getElementById("btnsearch")
                                .removeAttribute("disabled");
                        }
                    });

                i++;
            } while (i <= 12);
        });

        //Get Type of Location
        document
            .querySelector(".location-type-base")
            .addEventListener("click", function (e) {
                //Input Element Value
                SEARCHDATA.typeoflocation =
                    e.target.nodeName === "INPUT"
                        ? parseInt(e.target.value)
                        : parseInt(e.target.previousElementSibling.value);
            });

        //Get Select Search Data
        document
            .querySelector(".btnselectday")
            .addEventListener("click", function (e) {
                //Get Element Children from Turn Time
                let turnTimeBaseElement = [
                    ...document.querySelector(".inputbaseinterval").children,
                ];

                //Remove Children Elements
                turnTimeBaseElement.forEach((value) => {
                    if (value.getAttribute("type") !== "hidden") {
                        value.remove();
                    }
                });

                //Div Parent Html Element
                let div = htmlElement.createElement("div", {
                    class: "basebtnturn",
                });

                //Append Children
                document.querySelector(".inputbaseinterval").appendChild(div);

                //Create Calendar Append Element
                calendarRoutine.createAppendElement(
                    SEARCHDATA.typeoflocation,
                    "basebtnturn",
                    "select-turn-morning",
                    "select-turn-affternoon",
                    document
                        .getElementById("turn-refer-values")
                        .getAttribute("data-beginmorning"),
                    document
                        .getElementById("turn-refer-values")
                        .getAttribute("data-beginafternoon"),
                    document
                        .getElementById("turn-refer-values")
                        .getAttribute("data-blockhour"),
                );

                //Set Text for Indicate Search
                document.getElementById("search-date").textContent =
                    SEARCHDATA.filterbymonth.length > 0
                        ? calendarRoutine.searchContentMultipleMonths(
                              SEARCHDATA.filterbymonth,
                          )
                        : calendarRoutine.searchContent(
                              SEARCHDATA.filter,
                              SEARCHDATA.filter.month,
                              SEARCHDATA.filter.year,
                          );
            });

        //Get Element from Turn or Hour
        document
            .querySelector(".inputbaseinterval")
            .addEventListener("click", function (e) {
                //Disabled Submit Button
                document
                    .getElementById("btnsearch")
                    .setAttribute("disabled", true);

                //Check Element
                if (e.target.hasAttribute("data-action")) {
                    switch (e.target.getAttribute("data-action")) {
                        //List Turn buttons
                        case "list":
                            calendarRoutine.showHideTurnList(e.target);

                            break;

                        //Hour or period
                        case "hour":
                        case "period":
                            //Get Element
                            calendarRoutine.dynamicUpdateSelectTurnId(e.target);

                            //Check Element
                            SEARCHDATA.turndata =
                                calendarRoutine.setHourOrPeriod(
                                    SEARCHDATA.turndata,
                                    e.target,
                                );

                            break;
                    }
                }

                //Enabled Submit Button
                document
                    .getElementById("btnsearch")
                    .removeAttribute("disabled");
            });

        //Submit Search
        document
            .getElementById("btnsearch")
            .addEventListener("click", function (e) {
                //Prevent Default
                e.preventDefault();

                //Loading Routine
                defaultScripts.enabledLoadingAndDisableBtn("btnsearch");

                let showMessageError = false;

                //Check searchdata indicate values
                ["city", "searchtype"].forEach((value) => {
                    let contentObject = Object.getOwnPropertyDescriptor(
                        SEARCHDATA,
                        value,
                    );

                    //Check Value
                    if (!Number.isInteger(contentObject.value)) {
                        showMessageError = true;

                        return;
                    }
                });

                //Show Tooltip Message
                if (
                    showMessageError ||
                    document
                        .getElementById("search-date")
                        .textContent.includes("Quando")
                ) {
                    //Disable Loading and enable submit
                    defaultScripts.disableLoadingAndEnableBtn("btnsearch");

                    //Check base element
                    if (document.querySelector(".section-search")) {
                        //Create Html Element
                        if (!document.getElementById("tooltip-search-error")) {
                            let tooltip = htmlElement.createElement(
                                "span",
                                {
                                    class: "tooltip-search-error",
                                    id: "tooltip-search-error",
                                },
                                'É obrigatório selecionar "onde" e "quando" para a pesquisa',
                            );

                            //Append Element
                            document
                                .querySelector(".section-search")
                                .after(tooltip);
                        } else {
                            document
                                .getElementById("tooltip-search-error")
                                .classList.remove("d-none");
                        }

                        //Add Timeout
                        setTimeout(() => {
                            document
                                .getElementById("tooltip-search-error")
                                .classList.add("d-none");
                        }, 7500);

                        return;
                    }

                    //Render Response Message
                    responseMessage.renderResponseMessages(
                        document.querySelector(".responsebasemessage"),
                        "warning",
                        "Por favor informar os dados necessários para a pesquisa",
                        "d-flex",
                        7500,
                    );

                    return;
                }

                //Set Unique Conditional
                SEARCHDATA.month = [...new Set(SEARCHDATA.month)];
                SEARCHDATA.year = [...new Set(SEARCHDATA.year)];

                //Check Filter and Turn
                if (
                    (Object.values(SEARCHDATA.filter).length === 0 &&
                        SEARCHDATA.filterbymonth.length === 0) ||
                    SEARCHDATA.turndata.type === ""
                ) {
                    //Disable Loading and enable submit
                    defaultScripts.disableLoadingAndEnableBtn("btnsearch");

                    //alert("Os dados informados não são válidos");

                    //Set Search Data in Local Storage
                    sessionStorage.setItem(
                        "search_data",
                        JSON.stringify(SEARCHDATA),
                    );

                    //Redirect for Search Result
                    window.location.replace(`${HREF}/search-result`);

                    return;
                }

                //Check Type of Search
                switch (SEARCHDATA.turndata.type) {
                    //hour
                    case "hour":
                        //Check Values
                        let checkValues = calendarRoutine.checkValuesBeforeSend(
                            SEARCHDATA.turndata.datahour.begin,
                            SEARCHDATA.turndata.datahour.end,
                            "select-turn-morning",
                            "select-turn-affternoon",
                        );

                        //Check Conditional for Hour Error
                        if (!checkValues) {
                            //Disable Loading and enable submit
                            defaultScripts.disableLoadingAndEnableBtn(
                                "btnsearch",
                            );

                            //Render Response Message
                            responseMessage.renderResponseMessages(
                                document.querySelector(".responsebasemessage"),
                                "warning",
                                "Por favor informar a hora de fim maior que a hora de início",
                                "d-flex",
                                7500,
                            );

                            return;
                        }

                        break;

                    //turn
                    case "turn":
                        if (!Number.isInteger(SEARCHDATA.turndata.data)) {
                            //Disable Loading and enable submit
                            defaultScripts.disableLoadingAndEnableBtn(
                                "btnsearch",
                            );

                            //Render Response Message
                            responseMessage.renderResponseMessages(
                                document.querySelector(".responsebasemessage"),
                                "warning",
                                "Por favor informar o período",
                                "d-flex",
                                7500,
                            );

                            return;
                        }

                        break;
                }

                //Send Data
                let response = fetchData.structureTosendData(
                    `${HREF}/search`,
                    SEARCHDATA,
                    document.querySelector('meta[name="csrf-token"]').content,
                    "POST",
                );

                //Check Response
                response
                    .then((value) => {
                        //Disable Loading and enable submit
                        defaultScripts.disableLoadingAndEnableBtn("btnsearch");

                        //Check Callback Message
                        if (Object.is(value.classname, "success")) {
                            //Set Search Data in Local Storage
                            sessionStorage.setItem(
                                "search_data",
                                JSON.stringify(SEARCHDATA),
                            );

                            //Redirect for Search Result
                            window.location.replace(`${HREF}/search-result`);

                            return;
                        }

                        //Get Message
                        let message = Array.isArray(value.message)
                            ? value.message[0]
                            : value.message;

                        //Error Message
                        responseMessage.renderResponseMessages(
                            document.querySelector(".responsebasemessage"),
                            value.classname,
                            message,
                            "d-flex",
                            7500,
                        );

                        return;
                    })
                    .catch((error) => {
                        //Disable Loading and enable submit
                        defaultScripts.disableLoadingAndEnableBtn("btnsearch");

                        throw new Error(error);
                    });
            });
    }
})();
